module.exports = __webpack_public_path__ + "static/img/fish3.4637137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish3.png
// module id = NawE
// module chunks = 0